import { appConfig } from '@/config/app.ts'
import { DailyCutCashOutDetail } from '@/modules/services/dailyCut/types/DailyCutCashOutDetail.ts'

export interface DailyCutState {
  isLoading: boolean
  filters: string
  selectedAllyId: string
  isPayAmountModalOpen: boolean
  isProcesarPagoModalOpen: boolean
  selectedRows: DailyCutCashOutDetail[]
}

export const initialState: DailyCutState = {
  isLoading: false,
  filters: `?limit=${appConfig.pagination.defaultValue}`,
  selectedAllyId: '',
  isPayAmountModalOpen: false,
  isProcesarPagoModalOpen: false,
  selectedRows: []
}
